﻿import config from "../config"
const baseUrl = config.base_url + "container_indicator/"
export default {
    page: {
        url: baseUrl + "page/{limit}/{page}",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    reorder: {
        url: baseUrl + "reorder",
        type: "post",
    },
    listByContainerIdAndSource: {
        url: baseUrl + "listByContainerIdAndSource",
        type: "get",
    },
    listByContainerIdAndSources: {
        url: baseUrl + "listByContainerIdAndSources",
        type: "post",
    },
    // 测试相关接口
    getMockSampleData: {
        url: baseUrl + "getMockSampleData",
        type: "get",
    },    // 测试相关接口
    getMockFarmData: {
        url: baseUrl + "getMockFarmData",
        type: "get",
    },
    mockTestIndicators: {
        url: baseUrl + "mockTestIndicators",
        type: "get",
    }
}

